import React, { Component } from 'react';

class JobList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let jobs = this.props.data.map((job, index) => {
            return (
                <tr key={index}>
                    <td>{job.id}</td>
                    <td>{job.job_type.name}</td>
                    <td>{job.address_line_1}</td>
                    <td>{job.postcode}</td>
                    <td>{job.city}</td>
                    <td>{job.completion_date || 'Job not completed'}</td>
                    <td>
                        <button
                            onClick={(url) =>
                                this.props.onClick(
                                    this.props.isAdmin
                                        ? `${this.props.baseUrl}/jobs/${job.id}`
                                        : `/customers/${job.customer_id}/jobs/${job.id}`
                                )
                            }
                            className="btn btn-link btn-info"
                        >
                            <i className="fas fa-eye"></i>
                        </button>
                        {this.props.loadJobsMissingPO ? (
                            <button
                                className="btn btn-link btn-success"
                                onClick={() => this.props.handleJobIDChange(job.id)}
                                data-toggle="modal"
                                data-target="#exampleModal"
                            >
                                <i className="fas fa-pencil-alt"></i>
                            </button>
                        ) : (
                            ''
                        )}
                    </td>
                </tr>
            );
        });
        return (
            <table className="table transform-text">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Job type</th>
                        <th>Address line 1</th>
                        <th>Postcode</th>
                        <th>City</th>
                        <th>Completion date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>{jobs}</tbody>
            </table>
        );
    }
}

export default JobList;
